import { Injectable } from '@angular/core';

@Injectable()
export class CalcService {
  constructor() {}

  calcItemLocal() {}

  // Line Item Calculation Start

  // Cacl - 1, Use by inventory items only
  calcAmount(line: any) {
    var unitPrice = <number>line.unitPrice;
    var qty = <number>line.qty;
    const result = unitPrice * qty;
    return this.toCurrency(result);
  }

  calcDiscount(line: any) {
    const discount: string = line.discount;
    if (!discount) return 0;

    let amount = <number>line.amount;
    let result = 0;

    for (let discountItem of discount.split('/')) {
      let itemDiscountAmount = 0;
      if (discountItem.endsWith('%')) {
        const percent = +discountItem.substring(0, discountItem.length - 1);
        if (percent) itemDiscountAmount = amount * percent * 0.01;
      } else {
        itemDiscountAmount = +discountItem;
      }
      if (itemDiscountAmount > 0 && itemDiscountAmount <= amount) {
        amount -= itemDiscountAmount;
        result += itemDiscountAmount;
      }
    }
    return this.toCurrency(result);
  }

  // Cacl - 2
  calcSubAmount(line: any) {
    let amount = <number>line.amount;
    if (line.discountAmount) {
      const discountAmount = <number>line.discountAmount;
      amount -= discountAmount;
    }
    return amount;
  }

  // Cacl - 3
  calcTaxAmount(line: any) {
    var taxRate = <number>line.taxRate;
    var subAmount = <number>line.subAmount;
    var taxInclusive = <boolean>line.isTaxInclusive;
    var taxAmountAdjustment = <number>(line.taxAmountAdjustment || 0);
    const result = Number((taxInclusive
      ? +(subAmount * taxRate) / (1 + taxRate)
      : subAmount * taxRate).toFixed(2)) + taxAmountAdjustment;
    return this.toCurrency(result);
  }

  // Cacl - 3.1 jv debit
  calcTaxDebitAmount(line: any) {
    var taxRate = <number>line.taxRate;
    var amount = <number>line.debit;
    var taxInclusive = <boolean>line.isTaxInclusive;
    const result = Number((taxInclusive
      ? +(amount * taxRate) / (1 + taxRate)
      : amount * taxRate).toFixed(2));
    return this.toCurrency(result);
  }

  // Cacl - 3.2 jv credit
  calcTaxCreditAmount(line: any) {
    var taxRate = <number>line.taxRate;
    var amount = <number>line.credit;
    var taxInclusive = <boolean>line.isTaxInclusive;
    const result = Number((taxInclusive
      ? +(amount * taxRate) / (1 + taxRate)
      : amount * taxRate).toFixed(2));
    return this.toCurrency(result);
  }

  // Rental/Lease exempted tax amount (same formula as taxAmount but using rentalLeaseExemptedRate)
  calcRentalLeaseExemptedTaxAmount(line: any) {
    var rate = <number>(line.rentalLeaseExemptedRate ?? 0);
    var subAmount = <number>line.subAmount;
    var taxInclusive = <boolean>line.isTaxInclusive;
    const result = Number((taxInclusive
      ? +(subAmount * rate) / (1 + rate)
      : subAmount * rate).toFixed(2));
    return this.toCurrency(result);
  }

  // Rental/Lease exempted tax debit (JV)
  calcRentalLeaseExemptedTaxDebit(line: any) {
    var rate = <number>(line.rentalLeaseExemptedRate ?? 0);
    var amount = <number>line.debit;
    var taxInclusive = <boolean>line.isTaxInclusive;
    const result = Number((taxInclusive
      ? +(amount * rate) / (1 + rate)
      : amount * rate).toFixed(2));
    return this.toCurrency(result);
  }

  // Rental/Lease exempted tax credit (JV)
  calcRentalLeaseExemptedTaxCredit(line: any) {
    var rate = <number>(line.rentalLeaseExemptedRate ?? 0);
    var amount = <number>line.credit;
    var taxInclusive = <boolean>line.isTaxInclusive;
    const result = Number((taxInclusive
      ? +(amount * rate) / (1 + rate)
      : amount * rate).toFixed(2));
    return this.toCurrency(result);
  }

  // Cacl - 4
  calcWTaxAmount(line: any) {
    var wTaxRate = <number>line.wTaxRate;
    var taxAmount = <number>line.taxAmount;
    var subAmount = <number>line.subAmount;
    var taxInclusive = <boolean>line.isTaxInclusive;
    var wTaxAmountAdjustment = <number>(line.wTaxAmountAdjustment || 0);

    const result = taxInclusive
      ? (subAmount - taxAmount) * wTaxRate
      : subAmount * wTaxRate;

    return this.toCurrency(result + wTaxAmountAdjustment);
  }

  // Cacl - 4.1 jv debit
  calcWTaxDebitAmount(line: any) {
    var wtaxRate = <number>line.wTaxRate;
    var amount = <number>line.debit;
    var taxExclusiveDebit = <number>line.taxExclusiveDebit;
    var taxInclusive = <boolean>line.isTaxInclusive;

    const result = taxInclusive
      ? taxExclusiveDebit * wtaxRate
      : amount * wtaxRate;
    return this.toCurrency(result);
  }

  // Cacl - 4.2 jv credit
  calcWTaxCreditAmount(line: any) {
    var wtaxRate = <number>line.wTaxRate;
    var amount = <number>line.credit;
    var taxExclusiveCredit = <number>line.taxExclusiveCredit;
    var taxInclusive = <boolean>line.isTaxInclusive;
    const result = taxInclusive
      ? taxExclusiveCredit * wtaxRate
      : amount * wtaxRate;
    return this.toCurrency(result);
  }

  // Calc - 5
  calcTaxExclusiveAmount(line: any) {
    var taxInclusive = <boolean>line.isTaxInclusive;
    var subAmount = <number>line.subAmount;
    var taxAmount = <number>line.taxAmount;
    const result = taxInclusive ? subAmount - taxAmount : subAmount;
    return this.toCurrency(result);
  }

  // Calc - 5.1 jv debit
  calcTaxExclusiveDebit(line: any) {
    var taxInclusive = <boolean>line.isTaxInclusive;
    var amount = <number>line.debit;
    var taxAmount = <number>line.taxDebit;
    const result = taxInclusive ? amount - taxAmount : amount;
    return this.toCurrency(result);
  }

  // Calc - 5.2 jv credit
  calcTaxExclusiveCredit(line: any) {
    var taxInclusive = <boolean>line.isTaxInclusive;
    var amount = <number>line.credit;
    var taxAmount = <number>line.taxCredit;
    const result = taxInclusive ? amount - taxAmount : amount;
    return this.toCurrency(result);
  }

  // Calc - 6
  calcTaxInclusiveAmount(line: any) {
    var taxInclusive = <boolean>line.isTaxInclusive;
    var subAmount = <number>line.subAmount;
    var taxAmount = <number>line.taxAmount;
    const result = taxInclusive ? subAmount : subAmount + taxAmount;
    return this.toCurrency(result);
  }

  // Calc - 7
  calcNetAmount(line: any) {
    let taxExclusiveAmount = +line.taxExclusiveAmount;
    let taxAmount = +line.taxAmount;
    let wTaxAmount = +line.wTaxAmount;
    let wVatAmount = line.wVatAmount ? +line.wVatAmount : 0;

    let result = taxExclusiveAmount + taxAmount - wTaxAmount - wVatAmount;

    return this.toCurrency(result);
  }

  // Calc - 7.1 jv debit
  calcNetDebit(line: any) {
    let taxExclusiveAmount = +line.taxExclusiveDebit;
    let taxAmount = +line.taxDebit;
    let wtaxAmount = +line.wTaxDebit;

    let result = taxExclusiveAmount + taxAmount - wtaxAmount;
    return this.toCurrency(result);
  }

  // Calc - 7.2 jv credit
  calcNetCredit(line: any) {
    let taxExclusiveAmount = +line.taxExclusiveCredit;
    let taxAmount = +line.taxCredit;
    let wtaxAmount = +line.wTaxCredit;

    let result = taxExclusiveAmount + taxAmount - wtaxAmount;
    return this.toCurrency(result);
  }

  //for SVTD
  calcServiceAmount(line: any) {
    let result = 0;
    if (line.taxCode && line.taxCode.govTaxCode == 'SVTD')
      result = this.calcNetAmount(line);

    return this.toCurrency(result);
  }

  //for e-invoice
  calcAmountExemptedTax(line: any) {
    let result = 0;
    if (line.taxCode && line.taxCode.taxType == 2) {
      if (line.unitPrice && line.taxCode.qty) {
        result = this.calcAmount(line);
      } else if (line.amount) {
        result = line.amount;
      }
    }
    return this.toCurrency(result);
  }

  // for jv debit amount exempt from tax
  calcAmountExemptedTaxDebit(line: any) {
    let result = 0;
    if (line.taxCode && line.taxCode.taxType == 2) {
      result = line.debit;
    }
    return this.toCurrency(result);
  }

  // for jv credit amount exempt from tax
  calcAmountExemptedTaxCredit(line: any) {
    let result = 0;
    if (line.taxCode && line.taxCode.taxType == 2) {
      result = line.credit;
    }
    return this.toCurrency(result);
  }

  // for exempted tax amount
  calcTaxExemptionAmount(line: any) {
    let result = 0;
    let exemptionRate = line.taxExemptionRate ? line.taxExemptionRate : 0;
    if (exemptionRate > 0) {
      result = line.amount * exemptionRate;
    }
    return this.toCurrency(result);
  }

  // for jv debit exempted tax amount
  calcTaxExemptionAmountDebit(line: any) {
    let result = 0;
    let exemptionRate = line.taxExemptionRate ? line.taxExemptionRate : 0;
    if (exemptionRate > 0) {
      result = line.debit * exemptionRate;
    }
    return this.toCurrency(result);
  }

  // for jv credit exempted tax amount
  calcTaxExemptionAmountCredit(line: any) {
    let result = 0;
    let exemptionRate = line.taxExemptionRate ? line.taxExemptionRate : 0;
    if (exemptionRate > 0) {
      result = line.credit * exemptionRate;
    }
    return this.toCurrency(result);
  }

  //for WVat
  calcWVatAmount(line: any) {
    var wVatRate = <number>line.wVatRate;
    var taxRate = 1 + <number>line.taxRate;
    var subAmount = <number>line.subAmount;
    var taxInclusive = <boolean>line.isTaxInclusive;

    const result = taxInclusive
      ? (subAmount / taxRate) * wVatRate
      : subAmount * wVatRate;

    return this.toCurrency(result);
  }
  // Line Item Calculation End

  // Header Calculation Start
  calcInventoryTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'amount'));
  }

  calcTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'amount'));
  }

  calcTotalDebit(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'netDebit'));
  }

  calcTotalCredit(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'netCredit'));
  }

  calcTaxTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'taxAmount'));
  }

  calcRentalLeaseExemptedTaxTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'rentalLeaseExemptedTaxAmount'));
  }

  calcTaxDebitTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'taxDebit'));
  }

  calcTaxCreditTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'taxCredit'));
  }

  calcRentalLeaseExemptedTaxTotalDebit(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'rentalLeaseExemptedTaxDebit'));
  }

  calcRentalLeaseExemptedTaxTotalCredit(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'rentalLeaseExemptedTaxCredit'));
  }

  calcWTaxDebitTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'wTaxDebit'));
  }

  calcWTaxCreditTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'wTaxCredit'));
  }

  calcDiscountTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'discountAmount'));
  }

  calcSubtotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'subAmount'));
  }

  calcWTaxTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'wTaxAmount'));
  }

  calcWVatTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'wVatAmount'));
  }

  calcNetTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'netAmount'));
  }

  calcTaxExclusiveTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'taxExclusiveAmount'));
  }

  calcTaxInclusiveTotalAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'taxInclusiveAmount'));
  }

  // for SVTD
  calcTotalServiceAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'serviceAmount'));
  }

  // for amount exempt from tax
  calcTotalAmountExemptedTax(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'amountExemptedTax'));
  }

  // for jv debit amount exempt from tax
  calcTotalAmountExemptedTaxDebit(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'amountExemptedTaxDebit'));
  }

  // for jv credit amount exempt from tax
  calcTotalAmountExemptedTaxCredit(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'amountExemptedTaxCredit'));
  }

  // for exempt tax amount
  calcTotalTaxExemptionAmount(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'taxExemptionAmount'));
  }

  // for jv debit exempt tax amount
  calcTotalTaxExemptionAmountDebit(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'taxExemptionAmountDebit'));
  }

  // for jv creditexempt tax amount
  calcTotalTaxExemptionAmountCredit(lines: any[]) {
    return this.toCurrency(this.sum(lines, 'taxExemptionAmountCredit'));
  }
  //Header Calculation End

  // Past Header Calculation Start
  calcPastTaxTotalAmount(header: any) {
    var taxRate = header.docTaxCode ? <number>header.docTaxCode.rate : 0;
    var subAmount = <number>header.subtotalAmount;
    var taxInclusive = <boolean>header.isTaxInclusive;
    const result = Number((taxInclusive
      ? +(subAmount * taxRate) / (1 + taxRate)
      : subAmount * taxRate).toFixed(2));
    return this.toCurrency(result);
  }

  calcPastTaxExclusiveTotalAmount(header: any) {
    var taxInclusive = <boolean>header.isTaxInclusive;
    var subAmount = <number>header.subtotalAmount;
    var taxAmount = <number>header.taxTotalAmount;
    const result = taxInclusive ? subAmount - taxAmount : subAmount;
    return this.toCurrency(result);
  }

  calcPastNetTotalAmount(header: any) {
    var taxExclusiveAmount = +header.taxExclusiveTotalAmount;
    var taxAmount = +header.taxTotalAmount;
    const result = taxExclusiveAmount + taxAmount;
    return this.toCurrency(result);
  }
  // Past Header Calculation End

  calcLocal(base: number, currencyRate: number) {
    return Math.round(base * currencyRate * 100) / 100;
  }

  frontEndRounding(value: number): number {
    const totalCents = +(value * 100).toFixed(0);
    const cents = totalCents % 5;

    const roundDownValue = +((totalCents - cents) * 0.01).toFixed(2);

    if (cents <= 2) {
      return roundDownValue;
    }

    return roundDownValue + 0.05;
  }

  private sum(lines: any[], key: string) {
    let result = 0;
    for (let item of lines) {
      if (item?.isSubItem === true) continue;
      result += Number(item[key] || 0);
    }
    return result;
  }
  private toCurrency(base: number) {
    return Math.round(base * 100) / 100;
  }
}
